class UtilityBar extends HTMLElement {
  constructor() {
    super();

    this.desktopHeaderHeight = 125;
    this.utilityBarDesktopHeight = 37;
    this.utilityBarMobileHeight = 51;
    this.imageBarItems = document.querySelectorAll('.image-bar--x-large .image-bar__item');
    this.debug = true; // Enable debugging
  }

  connectedCallback() {
    document.documentElement.style.setProperty('--collection-description-top', '95px');
    document.documentElement.style.setProperty('--page-header-height', '155px');
    this.stickyHeader = document.querySelector('sticky-header.header-wrapper');
    this.contentForLayout = document.querySelector('main.content-for-layout');
    this.homepageHeader = document.querySelector('.homeopage-header');
    this.restaurantHeader = document.querySelector( '.restaurant-header' );
    this.restaurantSecondaryHeader = document.querySelector( '.restaurant-page-nav-container.section-header' );
    if ( !this.restaurantSecondaryHeader ) {
      this.restaurantSecondaryHeader = document.querySelector( '.restaurant-menu-nav-container.section-header' );
    }
    this.topCaviarNavBar = document.querySelector( 'nav.topbar' );

    if (this.debug) {
      console.log('=== UTILITY BAR DEBUG ===');
      console.log('Initial state:');
      console.log('  this.offsetHeight:', this.offsetHeight);
      console.log('  this.getBoundingClientRect():', this.getBoundingClientRect());
      console.log('  stickyHeader element:', this.stickyHeader);
      console.log('  stickyHeader classes:', this.stickyHeader?.className);
      console.log('  stickyHeader.style.top (before):', this.stickyHeader?.style.top);
      console.log('  stickyHeader computed top (before):', this.stickyHeader ? getComputedStyle(this.stickyHeader).top : 'N/A');
      console.log( '  stickyHeader computed position:', this.stickyHeader ? getComputedStyle( this.stickyHeader ).position : 'N/A' );
      console.log(' stickyHeader offsetHeight:', this.stickyHeader?.offsetHeight);
    }

    // Wait for layout to settle before measuring and setting positions
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.setPositions('after RAF');

        // If we still got 0, try again after a short delay
        const innerUtilityBar = this.querySelector('.utility-bar');
        const measuredHeight = innerUtilityBar ? innerUtilityBar.offsetHeight : this.offsetHeight;
        if (measuredHeight === 0) {
          setTimeout(() => {
            if (this.debug) console.log('Retrying measurement after 100ms...');
            this.setPositions('after 100ms retry');
          }, 100);
        }
      });
    });

    // Also check on window load as backup
    if (document.readyState === 'loading') {
      window.addEventListener('load', () => {
        if (this.debug) console.log('Window loaded, rechecking positions...');
        this.setPositions('on window load');
      }, { once: true });
    }

    // Monitor scroll to detect the jump
    let scrollCount = 0;
    const scrollHandler = () => {
      scrollCount++;
      if (scrollCount <= 5 && this.debug) {
        console.log(`Scroll #${scrollCount}:`, {
          utilityBarTop: this.getBoundingClientRect().top,
          utilityBarHeight: this.offsetHeight,
          stickyHeaderTop: this.stickyHeader?.getBoundingClientRect().top,
          stickyHeaderStyleTop: this.stickyHeader?.style.top,
          stickyHeaderComputedTop: this.stickyHeader ? getComputedStyle(this.stickyHeader).top : 'N/A'
        });
      }
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  setPositions(caller = 'unknown') {
    if (this.debug) {
      console.log(`setPositions called from: ${caller}`);
      console.log('  this (custom element) offsetHeight:', this.offsetHeight);
    }

    let mql = window.matchMedia('(max-width: 749px)');
    const isMobile = mql.matches;

    // Try to measure the inner .utility-bar div which has the actual styling
    const innerUtilityBar = this.querySelector('.utility-bar');
    let actualUtilityBarHeight = innerUtilityBar ? innerUtilityBar.offsetHeight : this.offsetHeight;
    let headerHeight = this.stickyHeader?.offsetHeight + actualUtilityBarHeight;

    // Fallback to hardcoded values if measurement is 0
    if (actualUtilityBarHeight === 0) {
      actualUtilityBarHeight = isMobile ? this.utilityBarMobileHeight : this.utilityBarDesktopHeight;
      if (this.debug) {
        console.log('  WARNING: Measured height is 0, using fallback');
      }
    }

    if (this.debug) {
      console.log('  innerUtilityBar element:', innerUtilityBar);
      console.log('  innerUtilityBar offsetHeight:', innerUtilityBar?.offsetHeight);
      console.log('  Expected mobile height:', this.utilityBarMobileHeight);
      console.log('  Expected desktop height:', this.utilityBarDesktopHeight);
      console.log('  Is mobile:', isMobile);
      console.log('  Using height:', actualUtilityBarHeight);
    }

    // Set CSS custom property at root level so all CSS rules can use it
    document.documentElement.style.setProperty('--utility-bar-height', actualUtilityBarHeight + 'px');

    // ALSO set it directly as inline style with !important as backup
    if (this.stickyHeader) {
      this.stickyHeader.style.setProperty('top', actualUtilityBarHeight + 'px', 'important');
    }

    // Also check for .section-header element which might have the sticky class
    const sectionHeader = document.querySelector('.section-header');
    if (sectionHeader && this.debug) {
      console.log('  .section-header element:', sectionHeader);
      console.log('  .section-header classes:', sectionHeader.className);
      console.log('  .section-header computed top:', getComputedStyle(sectionHeader).top);
      console.log('  .section-header computed position:', getComputedStyle(sectionHeader).position);
    }
    if (sectionHeader) {
      sectionHeader.style.setProperty('top', actualUtilityBarHeight + 'px', 'important');
    }

    if (isMobile) {
      this.imageBarItems.forEach((image_bar_item) => {
        const hight_adjust = this.desktopHeaderHeight + this.utilityBarDesktopHeight;
      });
      if ( this.restaurantSecondaryHeader ) {
        this.restaurantSecondaryHeader.style.setProperty( 'top', headerHeight + 'px', 'important' );
      }
    } else {
      if ( this.topCaviarNavBar ) {
        this.topCaviarNavBar.style.setProperty('top', '122px', 'important');
      }
      if ( this.restaurantSecondaryHeader ) {
        this.restaurantSecondaryHeader.style.setProperty( 'top', headerHeight + 'px', 'important');
      }
      this.imageBarItems.forEach((image_bar_item) => {
        const hight_adjust = this.desktopHeaderHeight + this.utilityBarDesktopHeight;
      });
    }

    if (this.restaurantHeader || this.homepageHeader) {
      this.contentForLayout.style.marginTop = '102px';
    } else {
      this.contentForLayout.style.marginTop = '122px';
    }

    if (this.debug) {
      console.log('  --utility-bar-height set to:', actualUtilityBarHeight + 'px');
      console.log('  stickyHeader.style.top set to:', this.stickyHeader?.style.top);
      console.log('  stickyHeader computed top (after):', this.stickyHeader ? getComputedStyle(this.stickyHeader).top : 'N/A');
      console.log('  stickyHeader computed position (after):', this.stickyHeader ? getComputedStyle(this.stickyHeader).position : 'N/A');
      console.log('=========================');
    }
  }
}
customElements.define('utility-bar', UtilityBar);
